import { combineReducers } from 'redux'
import {
  ADD_NOTIFICATION,
  CHANGE_ALIAS,
  CHANGE_CUSTOMER,
  CHANGE_EMAIL,
  CHANGE_LANG,
  DONE,
  ERROR,
  GET_CUSTOMERS_FAILURE,
  GET_CUSTOMERS_PROCESSING,
  GET_CUSTOMERS_SUCCESS,
  PROCESSING,
  REMOVE_NOTIFICATION,
  UPDATE_TOKEN,
  UPDATE_ID_TOKEN,
} from '../Constants'

const RootReducer = (state, action) =>
  combineReducers({
    lang,
    token,
    idToken,
    userInfo,
    customer,
    notifications
  })(state, action)

const lang = (state = 'ru', action) => action.type === CHANGE_LANG && action.lang || state

const token = (state = null, action) => action.type === UPDATE_TOKEN && action.token || state

export const idToken = (state = null, action) => {
  switch (action.type) {
    case UPDATE_ID_TOKEN:
      return action.token;
    default:
      return state;
  }
};

const customer = (state = {}, action) => {
  switch (action.type) {
    case GET_CUSTOMERS_SUCCESS:
      return action.data && action.data.assignCustomers[0] || null
    case CHANGE_CUSTOMER:
      return action.customer
    case CHANGE_ALIAS:
      if (state.id === action.id) {
        return { ...state, alias: action.customerAlias }
      }
  }
  return state
}

const notifications = (state = {}, action) => {
  switch (action.type) {
    case ADD_NOTIFICATION:
      return {
        ...state,
        [new Date().getTime()]: {
          message: action.message,
          error: action.error
        }
      }
    case REMOVE_NOTIFICATION:
      return Object.keys(state)
                   .filter(key => key !== action.id)
                   .reduce((obj, key) => ({ ...obj, [key]: state[key] }), {})
    default:
      return state
  }
}

const userInfo = (state = {}, action) => {
  switch (action.type) {
    case GET_CUSTOMERS_PROCESSING:
      return {
        status: PROCESSING
      }
    case GET_CUSTOMERS_SUCCESS:
      return {
        ...state,
        status: DONE,
        ...action.data
      }
    case GET_CUSTOMERS_FAILURE:
      return {
        status: ERROR
      }
    case CHANGE_ALIAS:
      return {
        ...state,
        customers: state.assignCustomers.map(customer => {
          if (customer.bin === action.bin) {
            customer.alias = action.customerAlias;
          }
          return customer;
        })
      }
    case CHANGE_EMAIL:
      return {
        ...state,
        email: action.email
      }
    default:
      return state
  }
}

export default RootReducer